// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__0MFX5","input":"styles_input__8rLQF","error":"styles_error__78f7P"};